var _defs, _ellipse, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _rect, _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "forget_password",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #004d77;\n        stroke-miterlimit: 10;\n        stroke-width: 20.03px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #1e938d;\n      }\n\n      .cls-3, .cls-4, .cls-2, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: #2bbbb2;\n      }\n\n      .cls-7 {\n        clip-path: url(#forget_pass_svg__clippath);\n      }\n\n      .cls-8 {\n        font-family: Somatic-Rounded, Somatic;\n        font-size: 214.5px;\n        isolation: isolate;\n      }\n\n      .cls-8, .cls-6 {\n        fill: #004d77;\n      }\n\n      .cls-5 {\n        fill: #d3d8da;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "forget_pass_svg__clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 518.5,
    cy: 486.3,
    r: 286.5
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 507,
    cy: 964.3,
    rx: 388.7,
    ry: 77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M554.6,96.3c-.3,18.2-13.7,33.1-31.2,35.8l-1.5,104c0,3.3-2.8,6-6.2,6s-6-2.8-6-6.2l1.5-104c-17.3-3.1-30.4-18.4-30.1-36.7.3-20.3,17-36.5,37.3-36.2,20.3.4,36.5,17,36.2,37.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Back_Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535.1,819.2c0,9.2-7.4,16.6-16.6,16.6s-16.6-7.4-16.6-16.6c0-7,4.3-13,10.5-15.4v-102.7c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1v102.7c6.1,2.4,10.5,8.4,10.5,15.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__R_Leg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Feet"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M753.4,936.7c0,12.9,10.5,23.4,23.4,23.4s23.4-10.5,23.4-23.4c0-8.7-4.7-16.3-11.8-20.3l17.8-189.2c.5-5.3-3.4-10-8.7-10.5s-10,3.4-10.5,8.7l-17.8,189.2c-9.2,3.1-15.8,11.8-15.8,22.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M695,665.8l69.5,49.5c-1.2,3.4-1.8,7.1-1.8,11,0,18.7,15.2,33.9,33.9,33.9s33.9-15.2,33.9-33.9-15.2-33.9-33.9-33.9c-7.9,0-15.1,2.7-20.8,7.2l-69.5-49.5c-4.3-3.1-10.4-2.1-13.5,2.3-3.1,4.3-2.1,10.3,2.2,13.4Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__L_Leg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Feet-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.5,936.7c0,12.9-10.5,23.4-23.4,23.4s-23.4-10.5-23.4-23.4c0-8.7,4.7-16.3,11.8-20.3l-17.8-189.2c-.5-5.3,3.4-10,8.7-10.5s10,3.4,10.5,8.7l17.8,189.2c9.2,3.1,15.8,11.8,15.8,22.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Leg-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.8,665.8l-69.5,49.5c1.2,3.4,1.8,7.1,1.8,11,0,18.7-15.2,33.9-33.9,33.9s-33.9-15.2-33.9-33.9,15.2-33.9,33.9-33.9c7.9,0,15.1,2.7,20.8,7.2l69.5-49.5c4.3-3.1,10.4-2.1,13.5,2.3,3.2,4.3,2.2,10.3-2.2,13.4Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__finomate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Body"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 518.5,
    cy: 486.3,
    r: 286.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225,313c-5.7,173.3,108.3,322.3,260.7,356,121.3,26.8,251.9-22.7,335.1-125.9,37.2,60.5,85.3,159.3,50.3,239.8-87.1,200.3-671.7,245.5-791.2,4.8-63.4-127.8,12.9-318.8,145.1-474.7Z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__R_Hand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Leg-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M717.2,633.1l107.4,15.2c.6,7.5,3.4,15,8.7,21.2,13.3,15.7,36.8,17.7,52.5,4.5,15.7-13.3,17.7-36.8,4.4-52.5s-36.8-17.7-52.5-4.5c-4.2,3.5-7.4,7.7-9.6,12.4l-108.1-15.4c-5.3-.8-10.2,2.9-10.9,8.2-.8,5.2,2.9,10.1,8.1,10.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Feet-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M943.6,457.4c.2-14.4-11.2-26.3-25.6-26.5s-26.3,11.2-26.5,25.6c-.1,8.6,3.9,16.4,10.3,21.2l-39.6,155.3c-1.3,5.2,1.8,10.4,7,11.7s10.4-1.8,11.7-7l39.5-155c12.8-1.2,23-12,23.2-25.3Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M916.8,403.3h0c-19.2,0-34.8-15.6-34.8-34.8v-62c0-19.2,15.6-34.8,34.8-34.8h0c19.2,0,34.8,15.6,34.8,34.8v62c0,19.3-15.6,34.8-34.8,34.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M968.5,466.7h-104.4c-12.3,0-22.4-10-22.4-22.4v-94.6c0-12.3,10-22.4,22.4-22.4h104.4c12.3,0,22.4,10,22.4,22.4v94.6c0,12.4-10.1,22.4-22.4,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M915.7,439.7h0c-7.4,0-13.4-6-13.4-13.4v-13.8c0-7.4,6-13.4,13.4-13.4h0c7.4,0,13.4,6,13.4,13.4v13.8c0,7.4-6,13.4-13.4,13.4Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__L_Hand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Leg-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M447.3,711.7l-72.3,80.9c4.4,6.1,7,13.6,7,21.8,0,20.6-16.7,37.3-37.3,37.3s-37.3-16.7-37.3-37.3,16.7-37.3,37.3-37.3c5.4,0,10.6,1.2,15.3,3.3l72.8-81.5c3.5-4,9.7-4.3,13.6-.8,4.1,3.5,4.5,9.7.9,13.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Feet-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M414,991.2c0,14.4-11.7,26.1-26.1,26.1s-26.1-11.7-26.1-26.1c0-8.6,4.2-16.3,10.7-21l-37-156c-1.2-5.2,2-10.4,7.2-11.6,5.2-1.2,10.4,2,11.6,7.1l37,155.6c12.7,1.6,22.7,12.6,22.7,25.9Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "forget_pass_svg__Eye"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M521.6,598.4c-96.7,0-175.4-78.7-175.4-175.4s78.7-175.4,175.4-175.4,175.4,78.7,175.4,175.4-78.7,175.4-175.4,175.4ZM521.6,289.9c-73.4,0-133.1,59.7-133.1,133.1s59.7,133.1,133.1,133.1,133.1-59.7,133.1-133.1-59.7-133.1-133.1-133.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 521.6,
    cy: 423,
    r: 116.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 581.1,
    cy: 395.9,
    r: 55.1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 771.6,
    y: 112.9,
    width: 165,
    height: 235.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(771.61 275.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M956.9,165c-3.6,14.3-16.4,23.8-30.4,23.8l-2.2,8.7c-1.1,4.6-5.7,7.4-10.4,6.2-4.4-1.1-7.2-5.8-6.1-10.4l4-16c1.1-4.6,5.8-7.4,10.3-6.3l.4.1c.1,0,.3.1.4.1,7.8,1.9,15.6-2.7,17.5-10.5s-2.7-15.6-10.5-17.5c-4.3-1.1-8.8-.1-12.2,2.4-3.8,2.9-9.1,2.2-12-1.7-2.7-3.8-2-9.1,1.8-11.8,7.6-5.8,17.4-7.7,26.6-5.4,16.7,4.4,27,21.4,22.8,38.3ZM918.2,223.9c-1.2,4.7-5.7,7.4-10.3,6.3l-1-.2c-4.6-1.1-7.3-5.7-6.1-10.4,1.1-4.4,5.7-7.3,10.2-6.1l1,.2c4.6,1.1,7.3,5.7,6.2,10.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.5742b0879c774fa4328e367f8e17c870.svg";
export { ForwardRef as ReactComponent };